/* tslint:disable */
/* eslint-disable */
export enum CreditNoteType {
  Normal = 'NORMAL',
  Chms = 'CHMS',
}
